module.exports = __webpack_public_path__ + "img/26.967e5d90.jpg";